import { render, staticRenderFns } from "./NoBuilder.vue?vue&type=template&id=076ddb64&"
import script from "./NoBuilder.vue?vue&type=script&lang=js&"
export * from "./NoBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports